import {
  DialogContent as MuiDialogContent,
  type DialogContentProps as MuiDialogContentProps,
  dialogTitleClasses,
  styled,
} from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

const TOP_PADDING_AFTER_TITLE = 1;

const DialogContentRoot = styled(MuiDialogContent)(({ theme }) => ({
  [`.${dialogTitleClasses.root} + &`]: {
    paddingTop: theme.spacing(TOP_PADDING_AFTER_TITLE),
  },
}));

type Props = WithoutStyleOverrides<MuiDialogContentProps>;

export function DialogContent(props: Props) {
  return <DialogContentRoot {...props} />;
}

export type { Props as DialogContentProps };
